// src/components/document/DocumentList.tsx
import React from 'react';

interface DocumentListProps {
  items: string[];
  listType: 'ordered' | 'unordered';
}

const DocumentList: React.FC<DocumentListProps> = ({ items, listType }) => {
  const ListTag = listType === 'ordered' ? 'ol' : 'ul';
  const listStyle =
    listType === 'ordered'
      ? 'list-decimal list-outside'
      : 'list-disc list-outside';

  return (
    <ListTag className={`space-y-2 pl-6 text-slate-700 ${listStyle}`}>
      {items.map((item, index) => {
        const processedItem = item.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        return <li key={index} dangerouslySetInnerHTML={{ __html: processedItem }} />;
      })}
    </ListTag>
  );
};

export default DocumentList;